import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../../../store/root-reducer';

import DoNotCallListDetails from './do-not-call-list-details';

import {
  AddPhoneNumberPayload,
  BulkDeletePhoneNumbersPayload,
  DeletePhoneNumbersPayload,
  GetDoNotCallListDetailsPayload,
  ImportPhoneNumbersViaCsvPayload,
  UpdateDoNotCallListPayload,
} from '../../../../types/do-not-call-list';
import {
  addPhoneNumberRequest,
  bulkDeletePhoneNumbersRequest,
  deletePhoneNumbersRequest,
  getDoNotCallListDetailsRequest,
  importPhoneNumbersViaCsvRequest,
  updateDoNotCallListRequest,
} from '../../extra-actions';
import { GetAgencyClientDropdownRequestPayload } from '../../../../../agency-client-management/types/request-payload';
import { getAgencyClientsDropdown } from '../../../../../agency-client-management/extra-actions';
import {
  clearPhoneNumbersSelection,
  resetAddPhoneNumberRequest,
  resetBulkDeletePhoneNumbersRequest,
  resetDeletePhoneNumbersRequest,
  resetGetDoNotCallListDetailsRequest,
  resetImportPhoneNumbersViaCsvRequest,
  resetSelectedPhoneNumbers,
  resetUpdateDoNotCallListRequest,
} from '../../do-not-call-slice';

const mapStateToProps = (state: RootState) => ({
  getDoNotCallListDetailsRequestStatus:
    state.callDoNotContact.getDoNotCallListDetailsRequest.status,
  getDoNotCallListDetailsRequestError:
    state.callDoNotContact.getDoNotCallListDetailsRequest.error,

  updateDoNotCallListRequestStatus:
    state.callDoNotContact.updateDoNotCallListRequest.status,
  updateDoNotCallListRequestError:
    state.callDoNotContact.updateDoNotCallListRequest.error,

  addPhoneNumberRequestStatus:
    state.callDoNotContact.addPhoneNumberRequest.status,
  addPhoneNumberRequestError:
    state.callDoNotContact.addPhoneNumberRequest.error,

  deletePhoneNumbersRequestStatus:
    state.callDoNotContact.deletePhoneNumbersRequest.status,
  deletePhoneNumbersRequestError:
    state.callDoNotContact.deletePhoneNumbersRequest.error,

  bulkDeletePhoneNumbersRequestStatus:
    state.callDoNotContact.bulkDeletePhoneNumbersRequest.status,
  bulkDeletePhoneNumbersRequestError:
    state.callDoNotContact.bulkDeletePhoneNumbersRequest.error,

  importPhoneNumbersViaCsvRequestStatus:
    state.callDoNotContact.importPhoneNumbersViaCsvRequest.status,
  importPhoneNumbersViaCsvRequestError:
    state.callDoNotContact.importPhoneNumbersViaCsvRequest.error,

  doNotCallListDetails: state.callDoNotContact.doNotCallListDetails,
  doNotCallListDetailsPaginationOptions:
    state.callDoNotContact.doNotCallListDetailsPaginationOptions,

  selectedPhoneNumbers: state.callDoNotContact.selectedPhoneNumbers,
  bulkSelectedPhoneNumbers: state.callDoNotContact.bulkSelectedPhoneNumbers,

  agencyClients: state.agencyClient.clients,

  isDemoAccount: state.home.isDemoAccount,
  doNotCallListDetailsPayload:
    state?.callDoNotContact?.doNotCallListDetailsPayload,
});

const mapDispatchToProps = {
  sendGetDoNotCallListDetailsRequest: (
    payload: GetDoNotCallListDetailsPayload,
  ) => getDoNotCallListDetailsRequest(payload),
  resetGetDoNotCallListDetailsRequest: () =>
    resetGetDoNotCallListDetailsRequest(),

  sendUpdateDoNotCallListRequest: (payload: UpdateDoNotCallListPayload) =>
    updateDoNotCallListRequest(payload),
  resetUpdateDoNotCallListRequest: () => resetUpdateDoNotCallListRequest(),

  sendAddPhoneNumberRequest: (payload: AddPhoneNumberPayload) =>
    addPhoneNumberRequest(payload),
  resetAddPhoneNumberRequest: () => resetAddPhoneNumberRequest(),

  sendDeletePhoneNumbersRequest: (payload: DeletePhoneNumbersPayload) =>
    deletePhoneNumbersRequest(payload),
  resetDeletePhoneNumbersRequest: () => resetDeletePhoneNumbersRequest(),

  sendBulkDeletePhoneNumbersRequest: (payload: BulkDeletePhoneNumbersPayload) =>
    bulkDeletePhoneNumbersRequest(payload),
  resetBulkDeletePhoneNumbersRequest: () =>
    resetBulkDeletePhoneNumbersRequest(),

  sendImportPhoneNumbersViaCsvRequest: (
    payload: ImportPhoneNumbersViaCsvPayload,
  ) => importPhoneNumbersViaCsvRequest(payload),
  resetImportPhoneNumbersViaCsvRequest: () =>
    resetImportPhoneNumbersViaCsvRequest(),

  clearPhoneNumbersSelection: () => clearPhoneNumbersSelection(),
  resetSelectedPhoneNumbers: () => resetSelectedPhoneNumbers(),

  sendGetAgencyClientsDropdownRequest: (
    payload: GetAgencyClientDropdownRequestPayload,
  ) => getAgencyClientsDropdown(payload),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector>;

export default connector(DoNotCallListDetails);
